<template>
    <div>
        <div class="alert alert-success" v-if="sent">
            {{ __('Thank you for your submission.') }}
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label">{{ __('Name') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('name') }" v-model="data.name">
                    <div class="invalid-feedback" v-if="hasError('name')">
                        <span v-for="error in errors.name">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ __('Function') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('function') }"  v-model="data.function">
                    <div class="invalid-feedback" v-if="hasError('function')">
                        <span v-for="error in errors.function">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label">{{ __('Municipality') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('municipality') }" v-model="data.municipality">
                    <div class="invalid-feedback" v-if="hasError('municipality')">
                        <span v-for="error in errors.municipality">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ __('Email address') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('email') }" v-model="data.email">
                    <div class="invalid-feedback" v-if="hasError('email')">
                        <span v-for="error in errors.email">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ __('Please tell us about your motivation to participate') }}</label>
                <textarea class="form-control" rows="5" v-model="data.motivation"></textarea>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ __('Upload your contract') }} <small class="text-muted">({{ __('Max :size MB', {'size' : 10 }) }})</small></label>
                <div v-if="data.uploads.length" v-for="upload, row in data.uploads" class="text-muted">
                    {{ upload.filename }} <a :href="'/award-submissions/files/'+ upload.uuid" target="_blank"><i class="fa fa-download"></i></a> <a href="#" class="text-danger" @click.prevent="data.uploads.splice(row, 1)"><i class="fa fa-trash"></i></a>
                </div>
                <div class="file-upload" :class="{ 'mt-2' : data.uploads.length }" v-if="showDropzone || !data.uploads.length">
                    <vue-dropzone :options="dropzoneOptions" id="upload-dropzone" :use-custom-slot="true" @vdropzone-success="setUpload">
                        {{ __('Drop a file or click to browse.') }}
                    </vue-dropzone>
                </div>
                <div v-else>
                    <button class="btn btn-primary text-white btn-sm mt-2" @click="showDropzone = true">{{ __('Add another file') }} <i class="fa fa-plus"></i></button>
                </div>
            </div>
            <div class="mb-3">
                <recaptcha :language="language" ref="recaptcha" :sitekey="siteKey" v-if="siteKey" @verify="captchaVerified"></recaptcha>
                <div class="invalid-feedback d-block" v-if="hasError('recaptcha')">
                    <span v-for="error in errors.recaptcha">{{ error }}</span>
                </div>
            </div>
            <button class="btn btn-lg btn-primary text-white" :class="{ disabled : sending }" @click="send"><i class="fa fa-spin fa-circle-notch" v-if="sending"></i> {{ __('Send') }} <i class="fa fa-chevron-right"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            show() {
                return show
            }
        },
        props: ['locale'],
        data() {
            return {
                sent : false,
                sending: false,
                errors: null,
                siteKey : null,
                language : null,
                showDropzone: true,
                dropzoneOptions: {
                    maxFiles: 1,
                    url: '/award-submissions/upload',
                    headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content},
                    maxFilesize: 10,
                },
                data : {
                    name : null,
                    function : null,
                    municipality : null,
                    email : null,
                    motivation : null,
                    uploads : [],
                    recaptcha : null,
                }
            }
        },
        methods: {
            send() {
                if (this.sending) {
                    return;
                }

                this.sending = true;
                axios.post('/'+ this.locale +'/award-submissions', this.data)
                     .then(response => {
                         this.sending = false;
                         this.sent = true;
                         this.errors = null;
                     }).catch(error => {
                         if (error.response.data && error.response.data.errors) {
                             this.errors = error.response.data.errors;
                         }
                         this.sending = false;
                         this.$refs.recaptcha.reset() // Direct call reset method
                })
            },
            hasError(field) {
                return this.errors && this.errors[field] && this.errors[field].length > 0;
            },
            captchaVerified(token) {
                this.data.recaptcha = token;
            },
            setUpload(file, response) {
                this.data.uploads.push(response);
                this.showDropzone = false;
            }
        },
        mounted() {
            this.language = window._locale;
            this.siteKey = window.google_site_key;

            this.dropzoneOptions.url = '/'+ this.locale + '/award-submissions/upload';
        },
    }
</script>
